import React from 'react'
import { renderReact } from '@frontend/utils/react-compat'
import { Index } from './parent/index'

renderReact(<Index />, document.getElementById('service_site_index'))
